export const roundPercentageChange =  (value) => (Math.round(1e4*value)/1e4)